import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '../../contexts/AuthProvider/AuthProvider';

const Header = () => {
    const { user, logOut } = useContext(AuthContext);
    const handleLogOut = () => {
        logOut()
            .then(() => {
                toast("Signed Out Successful!");
            })
            .catch(error => console.error(error));
    }
    return (
        <div className="navbar bg-[#fef2e5] lg:px-32 pt-6">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex={0} className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        <li><Link to={'/'}>Home</Link></li>
                        <li><Link to={'/foods'}>Foods</Link></li>
                        {
                            user?.uid ?
                                <>
                                    <li><Link to={'/my-reviews'}>My reviews</Link></li>
                                    <li><Link to={'/add-service'}>Add Service</Link></li>
                                </>
                                :
                                <></>
                        }
                        <li><Link to={'/blog'}>Blog</Link></li>
                    </ul>
                </div>
                <a href='/' className="btn btn-ghost normal-case text-xl"><img src="/Salmalogo.png" className='w-48 lg:w-64 mt-[-10px]' alt="" /></a>
            </div>
            <div className="navbar-center hidden lg:flex">
                <ul className="menu menu-horizontal p-0">
                    <li><Link to={'/'}>Home</Link></li>
                    <li><Link to={'/foods'}>Foods</Link></li>
                    {
                        user?.uid ?
                            <>
                                <li><Link to={'/my-reviews'}>My reviews</Link></li>
                                <li><Link to={'/add-service'}>Add Service</Link></li>
                            </>
                            :
                            <></>
                    }
                    <li><Link to={'/blog'}>Blog</Link></li>
                </ul>
            </div>
            <div className="navbar-end">
                {
                    user?.uid ?
                        <Link onClick={handleLogOut}><button className="btn">Log out</button></Link> :
                        <Link to={'/login'}><button className="btn btn-warning">Log in</button></Link>
                }

            </div>
        </div>
    );
};

export default Header;